module.exports = __webpack_public_path__ + "img/pain2.svg";